var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaturation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.000000 50.000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188 490 c-174 -52 -213 -289 -69 -423 92 -86 214 -89 256 -7 18 35 19 60 3 95 -11 24 -8 29 39 73 80 73 84 145 13 213 -54 52 -161 74 -242 49z m155 -21 c22 -6 55 -26 75 -44 33 -30 37 -38 37 -85 0 -49 -2 -53 -54 -101 -43 -40 -52 -53 -47 -72 21 -71 19 -85 -13 -118 -29 -29 -36 -31 -81 -27 -183 18 -278 270 -150 398 55 55 144 74 233 49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 434 c-30 -30 -10 -94 29 -94 21 0 45 29 45 55 0 26 -24 55 -45 55 -7 0 -21 -7 -29 -16z m49 -23 c7 -23 -3 -51 -20 -51 -7 0 -16 7 -19 16 -9 23 2 54 19 54 8 0 16 -8 20 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 384 c-30 -30 -10 -94 29 -94 21 0 45 29 45 55 0 26 -24 55 -45 55 -7 0 -21 -7 -29 -16z m49 -23 c12 -39 -25 -72 -39 -35 -9 23 2 54 19 54 8 0 16 -8 20 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346 384 c-30 -30 -10 -94 29 -94 21 0 45 29 45 55 0 26 -24 55 -45 55 -7 0 -21 -7 -29 -16z m49 -23 c7 -23 -3 -51 -20 -51 -7 0 -16 7 -19 16 -9 23 2 54 19 54 8 0 16 -8 20 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 254 c-30 -30 -10 -94 29 -94 21 0 45 29 45 55 0 26 -24 55 -45 55 -7 0 -21 -7 -29 -16z m49 -23 c7 -23 -3 -51 -20 -51 -17 0 -27 28 -20 51 8 24 32 24 40 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 150 c-11 -11 -20 -29 -20 -40 0 -26 34 -60 60 -60 26 0 60 34 60 60 0 26 -34 60 -60 60 -11 0 -29 -9 -40 -20z m70 -15 c26 -32 -13 -81 -47 -59 -10 6 -19 19 -21 28 -8 38 43 61 68 31z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaturation);
export default __webpack_public_path__ + "static/media/saturation.3e42d3f86b0454f1eb42670936a4d584.svg";
export { ForwardRef as ReactComponent };